/* CUBE STORE - collezioni (app Globo)
   1) mette il tasto CERCA e il tasto FILTRI dove servono: nella fila dei
      comandi in collezione, accanto alla barra del tema nei risultati;
   2) mette le etichette del pannello in italiano;
   3) posiziona il pannello a destra e sotto la testata, azzerando margine
      e altezza dell'app (li imposta con una regola piu' specifica del tema),
      e lo chiude con Esc;
   4) porta il nome del colore fuori dal titolo, accanto al codice;
   5) rete di sicurezza se l'app non parte;
   6) porta la fila delle famiglie sopra la griglia. */
(function () {
  function closePanel() {
    var btn = document.querySelector('.gf-close-canvas');
    if (btn) btn.click();
    else document.documentElement.classList.remove('offcanvas-open');
  }

  function template() {
    var main = document.getElementById('MainContent');
    return main ? main.dataset.template : '';
  }

  /* ---------- il tasto CERCA ---------- */
  /* PERCHE' LA BARRA DELL'APP E' STATA SOSTITUITA, il 18 agosto 2026.
     Segnalato da Alberto Quadrio: quella barra cerca solo dentro il reparto
     aperto. Non e' un sospetto, e' scritto nel codice dell'app, che accanto
     al campo stampa per i lettori di schermo la riga "Use this input to
     search products in this collection". Un cliente che sta guardando le
     E-Bike e cerca "casco" non trova niente, e non capisce perche'.

     Il negozio ha gia' una ricerca che guarda tutto: quella della lente in
     testata, che apre un pannello con i risultati mentre si scrive. Quindi
     invece di una seconda ricerca da mantenere, qui c'e' un tasto che apre
     quella. Deciso cosi' con Alberto: "o con la barra come immagine del
     pulsante" - l'aspetto resta identico a prima, cambia dove si va a
     cercare.

     COME SI APRE. La lente in testata e' un <button on:click=
     "#search-modal/showDialog">, cioe' il tema si aggancia da solo a quel
     bottone. Invece di rifare il giro noi - aprire il dialogo a mano,
     spostare il fuoco nel campo, gestire la chiusura - qui si preme quel
     bottone. Cosi' tutto quello che il tema fa all'apertura continua a farlo
     lui: misurato, il pannello si apre e il cursore e' gia' nel campo.

     Si cerca il bottone VISIBILE perche' in pagina ce ne sono due, uno per
     la testata larga e uno per il menu a cassetto, e quello di turno dipende
     dalla larghezza dello schermo: premere quello nascosto non farebbe
     niente.

     Se un domani la testata cambiasse e nessuno dei due ci fosse, si va
     comunque alla pagina di ricerca invece di lasciare un tasto morto.

     LA BARRA DELL'APP NON SI CANCELLA, si nasconde da cube-controlli.css:
     e' roba di Globo, che la ridisegna a ogni filtro applicato, e toglierla
     dal DOM vorrebbe dire rincorrerla. Nascosta non da' fastidio a nessuno. */

  var CUBE_LENTE =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.13 4.12a.9.9 0 1 1-1.28 1.28l-4.12-4.13A5.5 5.5 0 1 1 8.5 3Zm0 1.8a3.7 3.7 0 1 0 0 7.4 3.7 3.7 0 0 0 0-7.4Z"/>' +
    '</svg>';

  function apriRicerca() {
    var bottoni = document.querySelectorAll('search-button button');
    for (var i = 0; i < bottoni.length; i++) {
      if (bottoni[i].getBoundingClientRect().height > 0) {
        bottoni[i].click();
        return;
      }
    }
    window.location.href = '/search';
  }

  function bottoneCerca(selezione) {
    /* si ricerca ogni volta invece di tenerselo in una variabile: l'app
       ridisegna questa fila a ogni filtro applicato e il nostro tasto se ne
       va con lei. Se non c'e' piu', se ne fa un altro. */
    var b = document.querySelector('.cube-cerca-tutto');

    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'cube-cerca-tutto';
      b.setAttribute('aria-haspopup', 'dialog');
      b.setAttribute('aria-label', 'Cerca in tutto il negozio');
      b.innerHTML = CUBE_LENTE + '<span>Cerca Prodotti</span>';
      b.addEventListener('click', apriRicerca);
    }

    if (b.parentElement !== selezione) selezione.insertBefore(b, selezione.firstChild);
  }

  /* ---------- 1. dove vanno ricerca e FILTRI ---------- */
  /* Due situazioni diverse, e vanno tenute separate.

     NELLE COLLEZIONI, dal 17 agosto 2026, tutto sta su una riga sola.
     L'app sparge i suoi comandi in due contenitori: la barra di ricerca sta
     per conto suo in cima a #gf-controls-container, mentre CONFRONTA ORA e
     l'ordinamento stanno piu' sotto dentro .gf-filter-selection. Qui il
     tasto CERCA e il tasto FILTRI vengono messi dentro quel secondo
     contenitore, cosi' i quattro comandi diventano una fila unica. L'ordine
     in cui si leggono lo decide poi il CSS con order, vedi
     assets/cube-controlli.css.

     Fino al 18 agosto qui veniva spostata la barra dell'app. Adesso al suo
     posto c'e' il nostro tasto, per il motivo spiegato poco sopra.

     NELLA PAGINA DEI RISULTATI la ricerca di Globo e' spenta del tutto (vedi
     layout/theme.liquid): l'app lascia il suo modulo in pagina ma con
     display: none, e un elemento nascosto non occupa spazio, quindi FILTRI
     restava da solo appiccicato al bordo sinistro sotto al campo di ricerca
     del tema. Li' la barra a cui affiancarlo e' quella del tema
     (form.search-page-input__parent, dentro .search-page__header), che cerca
     gia' su tutto il negozio: li' non serve nessun tasto nostro.

     In tutti i casi si controlla dove sta gia' ogni pezzo prima di
     spostarlo: muovere un nodo e' una modifica del DOM, e l'osservatore in
     fondo al file fa ripartire tutto: senza il controllo si rientrerebbe
     qui a ogni frame. */

  function placeTrigger() {
    var trigger = document.querySelector('.gf-filter-trigger');
    if (!trigger) return;

    if (template() === 'collection') {
      var selezione = document.querySelector('.gf-actions .gf-filter-selection');
      if (!selezione) return;

      bottoneCerca(selezione);

      if (trigger.parentElement !== selezione) {
        var ordina = selezione.querySelector('.sort-by');
        if (ordina) selezione.insertBefore(trigger, ordina);
        else selezione.appendChild(trigger);
      }
      return;
    }

    var barra = document.querySelector('.search-page__header form.search-page-input__parent');
    if (!barra) return;

    var row = document.querySelector('.cube-search-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'cube-search-row';
      barra.parentElement.insertBefore(row, barra);
    }
    if (barra.parentElement !== row) row.appendChild(barra);
    if (trigger.parentElement !== row) row.appendChild(trigger);
  }

  /* ---------- 6. la fila delle famiglie ---------- */
  /* Le scorciatoie alle famiglie della categoria - Tutte | Attain | Agree |
     Litening - le costruisce snippets/cube-famiglie.liquid leggendo il menu
     di navigazione. Nascono nel layout, nascoste, perche' .gf-actions lo
     disegna l'app Globo e da Liquid non si raggiunge: qui vengono portate
     dentro, in testa, dove prima c'era il conteggio dei prodotti.

     Il conteggio non si nasconde da qui ma dal CSS, con un selettore che
     guarda se la fila c'e' (vedi cube-controlli.css): l'app ridisegna quel
     pezzo a ogni filtro applicato, e una proprieta' messa da JavaScript se
     ne andrebbe al primo ridisegno, mentre una regola CSS regge sempre.

     L'hidden si toglie DOPO lo spostamento, mai prima, se no per un istante
     la fila si vedrebbe in cima alla pagina. Il segno sul nodo evita di
     rientrare all'infinito: spostare un nodo e' una modifica del DOM, e
     l'osservatore fa ripartire tutto. */

  function famiglie() {
    if (template() !== 'collection') return;

    var nav = document.querySelector('.cube-famiglie');
    if (!nav || nav.dataset.cubePosata === '1') return;

    var azioni = document.querySelector('.gf-actions');
    if (!azioni) return;

    nav.dataset.cubePosata = '1';
    azioni.insertBefore(nav, azioni.firstChild);
    nav.hidden = false;
  }

  /* ---------- 2. etichette ---------- */

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  function labels() {
    var btn = document.querySelector('.gf-refine-toggle-mobile button');
    if (btn) {
      btn.setAttribute('aria-label', 'Filtri');
      var kids = btn.childNodes;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].nodeType === 3 && kids[i].nodeValue.trim() && kids[i].nodeValue.indexOf('Filtri') === -1) {
          kids[i].nodeValue = ' Filtri';
        }
      }
    }

    setText(document.getElementById('gf-filter-title'), 'Filtri');
    setText(document.querySelector('.globo-selected-items-wrapper .gf-block-title .h3 span'), 'Filtri attivi');

    var x = document.querySelector('.gf-close-canvas');
    if (x) x.setAttribute('aria-label', 'Chiudi filtri');
  }

  /* ---------- 3. geometria del pannello ---------- */
  /* La testata e' sticky e occupa sempre la stessa fascia in alto, quindi
     il suo bordo inferiore e' il punto di partenza del pannello. Lo misuro
     dal DOM invece di scriverlo a mano: cosi vale anche su mobile, dove la
     testata e' piu' bassa, e se un domani sparisce la barra annunci.

     La misura non invecchia mentre si scorre, e questo e' il motivo per
     cui il pannello puo' stare fermo con la pagina che scorre dietro: la
     testata non si sposta, quindi il pannello non ha bisogno di inseguirla.

     Perche' questo regga serve una riga in cube-filtri.css: l'app mette
     overflow: hidden sul body, e un body con overflow diverso da visible
     diventa il contenitore di scorrimento della testata sticky, che cosi'
     smette di stare ferma. Se un giorno il pannello dovesse tornare ad
     "andare in giro", si guarda li'. */

  function headerBottom() {
    var header = document.querySelector('.header');
    if (!header) return 0;
    var bottom = Math.round(header.getBoundingClientRect().bottom);
    return bottom > 0 ? bottom : 0;
  }

  function panel() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return;

    var top = headerBottom();
    if (tree.dataset.cubeTop === String(top)) return;
    tree.dataset.cubeTop = String(top);

    document.documentElement.style.setProperty('--cube-filter-top', top + 'px');
    tree.style.setProperty('margin', '0', 'important');
    tree.style.setProperty('top', top + 'px', 'important');
    tree.style.setProperty('height', 'calc(100% - ' + top + 'px)', 'important');
  }

  /* NIENTE SFONDO SCURO, NIENTE BLOCCO DELLA PAGINA

     Qui prima c'erano due pezzi che ora non ci sono piu': uno sfondo
     scuro cliccabile sopra la pagina, e la misura della barra di
     scorrimento che serviva a compensare il salto di lato quando la
     pagina veniva bloccata.

     Sono spariti insieme perche' rispondevano alla stessa idea - il
     pannello e' una finestra modale, dietro non si tocca niente - e non
     e' cosi che deve funzionare: si filtra guardando i prodotti, quindi
     la pagina dietro resta leggibile e scorrevole. Lo sfondo scuro faceva
     il contrario, spegneva proprio cio' che si sta guardando, e essendo
     cliccabile intercettava il clic su una bici per chiudere il pannello.
     Bloccata la pagina, poi, non c'e' piu' nessuna barra che sparisce e
     nessun salto da compensare.

     Per chiudere restano la X del pannello e il tasto Esc, qui sotto. */

  /* ---------- 4. colore accanto al codice ---------- */
  /* Il nome del colore esce dal titolo e va nella riga sotto, quella che
     il modello di Globo prepara per il codice (.cube-card-idline).

     Il colore lo porta il metafield "custom.colore", che il modello mette
     in data-colore, ma sui prodotti e' vuoto: allora si ricava dall'ultima
     parola del titolo, con la stessa regola di snippets/cube-colore.liquid,
     dove il colore e' sempre in fondo:
       - se contiene "n" fra due accenti (topasblue´n´white) e' un colore;
       - altrimenti vale solo se tutta minuscola, lunga almeno 5 lettere e
         senza cifre (teamline, actionteam). I nomi dei modelli CUBE sono
         maiuscoli o contengono numeri, quindi restano nel titolo.
     Se il metafield un giorno verra' popolato, quello ha la precedenza e la
     riga la scrive direttamente il modello di Globo. */

  function splitColor(title) {
    var words = title.trim().split(/\s+/);
    if (words.length < 2) return null;

    var last = words[words.length - 1];

    if (last.indexOf('´n´') === -1) {
      if (last !== last.toLowerCase()) return null;
      if (last.length < 5) return null;
      if (/[0-9]/.test(last)) return null;
    }

    return { title: words.slice(0, -1).join(' '), color: last };
  }

  function titles() {
    var cards = document.querySelectorAll('.spf-product-card__title');
    for (var i = 0; i < cards.length; i++) {
      var el = cards[i];
      if (el.dataset.cubeTitle === '1') continue;
      el.dataset.cubeTitle = '1';

      var link = el.querySelector('a');
      if (!link) continue;

      var text = link.textContent.trim();
      var colore = (el.dataset.colore || '').trim();

      if (colore) {
        /* metafield compilato: lo togliamo dalla coda del titolo, la riga
           accanto al codice l'ha gia' scritta il modello di Globo */
        if (text.length > colore.length &&
            text.slice(-colore.length).toLowerCase() === colore.toLowerCase()) {
          link.textContent = text.slice(0, text.length - colore.length).trim();
        }
        continue;
      }

      var parts = splitColor(text);
      if (!parts) continue;

      link.textContent = parts.title;

      var line = document.createElement('span');
      line.className = 'cube-card-colore';
      line.textContent = parts.color;

      /* Il colore va infilato DAVANTI al codice, dentro la riga che il
         modello di Globo prepara sotto il titolo. Prima veniva messo su
         una riga sua e i due dati restavano su due righe diverse.

         Il puntino di separazione non si scrive qui: e' un ::before del
         codice agganciato al colore col selettore fratello, quindi
         compare da solo quando il colore c'e' e non resta mai appeso.

         Se un domani il modello cambiasse e quella riga non ci fosse, si
         torna al comportamento di prima invece di perdere il colore. */
      var riga = el.parentElement.querySelector('.cube-card-idline');
      if (riga) riga.insertBefore(line, riga.firstChild);
      else el.parentElement.insertBefore(line, el.nextSibling);
    }
  }

  /* ---------- 5. rete di sicurezza ---------- */
  /* Nelle collezioni le schede del tema sono nascoste dal primo istante (vedi
     cube-card.css), perche' comanda Globo. Se pero' l'app non parte - errore
     suo, script bloccati, rete lenta - la pagina resterebbe senza prodotti:
     dopo 8 secondi senza nessuna scheda dell'app, la griglia del tema torna
     visibile.

     Importante: il controllo non e' una tantum. Se Globo arriva in ritardo,
     per esempio su una connessione lenta o su Safari, che carica gli script
     di terze parti con piu' calma, la classe va tolta appena compaiono le sue
     schede. Senza questo, la griglia del tema restava visibile in fondo alla
     pagina per sempre, che e' esattamente il difetto che la rete di sicurezza
     doveva evitare. Il controllo gira dentro run(), quindi a ogni modifica
     del DOM. */

  function fallback() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var tpl = main.dataset.template;
    if (tpl !== 'collection' && tpl !== 'search') return;

    /* l'app e' arrivata: via la rete di sicurezza, se era stata messa */
    if (document.querySelector('.spf-product-card')) {
      main.classList.remove('cube-globo-off');
      return;
    }

    if (main.dataset.cubeFallback === '1') return;
    main.dataset.cubeFallback = '1';

    setTimeout(function () {
      if (!document.querySelector('.spf-product-card')) {
        main.classList.add('cube-globo-off');
      }
    }, 8000);
  }

  /* ---------- avvio ---------- */

  var queued = false;
  function run() {
    queued = false;
    placeTrigger();
    famiglie();
    labels();
    panel();
    titles();
    fallback();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  function remeasure() {
    var tree = document.getElementById('gf-tree');
    if (tree) delete tree.dataset.cubeTop;
    schedule();
  }

  function init() {
    run();
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

    /* apertura e chiusura del pannello: la classe vive sull'elemento
       radice, che l'osservatore sul body non vede */
    new MutationObserver(remeasure).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', remeasure);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.documentElement.classList.contains('offcanvas-open')) closePanel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
